// extracted by mini-css-extract-plugin
module.exports =  {"container":"_9cadcb71c3--container--q5jzO","item":"_9cadcb71c3--item--y86vU","house":"_9cadcb71c3--house--EFKX_","newbuilding":"_9cadcb71c3--newbuilding--fz_pm"};